<template>
  <div>
    <v-row>
      <v-col cols="12"><h4> {{ $t('contract.infoSection') }} </h4></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.contractName"
          :label="$t('contract.name')"
          outlined
          @input="validationModel.form.contractName.$touch()"
          :error-messages="errorMessages(this.validationModel.form.contractName, 'contractName')"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="form.area"
          :items="areas"
          outlined
          :label="$tc('contract.area', 1)"
          return-object
          :disabled="areas.length === 1"
          item-text="name"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="form.project"
          :items="projectsList"
          outlined
          :label="$tc(`contract.project.${form.area.code}`, 1)"
          @change="validationModel.form.project.$touch()"
          :error-messages="errorMessages(this.validationModel.form.project, 'Project')"
          return-object
          item-text="label"
          :no-data-text="form.area.code ? $t('common.noData') : $t('common.firstSelectArea')"
        >
          <template v-slot:selection="{ item }">
            {{ item.label }}
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row dense class="mb-4">
      <v-col cols="12" class="py-0">
        <h4>
          {{ $t('contract.mainAndSubSection') }}
          <span v-if="!form.isParent" class="text--secondary font-weight-regular"> {{ $t('common.optional') }}</span>
        </h4>
      </v-col>
      <v-col cols="12">
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-row align="baseline" class="mx-1">
              <v-switch
                v-model="form.isParent"
                dense
                :disabled="!!form.parentContractId"
              />
              <span class="text--secondary">{{$t('contract.selectAsMain')}}</span>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="mb-1">
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="form.subContracts"
              :label="$t('contract.selectSubContracts')"
              :items="potentialSubContractsList"
              item-text="contractName"
              item-value="id"
              outlined
              return-object
              multiple
              @input="validationModel.form.subContracts.$touch()"
              :error-messages="errorMessages(validationModel.form.subContracts, 'subContracts')"
            >
              <template v-slot:selection="{}" />
              <template v-slot:item="{ item }">
                <v-list-item-title>{{ item.contractName }}</v-list-item-title>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-chip
              v-for="(subContract, index) in form.subContracts"
              :key="index"
              small
              close
              class="ma-1"
              @click:close="removeSubContractChip(index)"
            >
              {{ subContract.contractName }}
            </v-chip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ParentInfoSection',
  props: [
    'form',
    'validationModel',
    'errorMessages',
    'projects',
    'packages',
    'types',
    'areas'
  ],
  data () {
    return { }
  },
  computed: {
    ...mapState({
      contracts: (state) => state.contracts
    }),
    potentialSubContractsList () {
      return this.contracts
        .reduce((acc, curr) => {
          if (curr.id !== this.form.id && !this.form.subContracts.find(i => i.id === curr.id)) {
            curr.subContracts && curr.subContracts.length ? acc.push(...curr.subContracts) : acc.push(curr)
          }
          return acc
        }, [])
        .filter(i => i.projectId === this.form.project.id && !i.parentContractId && !i.isParent)
    },
    projectsList () {
      const mapProjectToEntries = (project) => {
        const name = project.code && project.code !== '' ? `${project.name} - ${project.code}` : project.name
        const projectAreas = (project.areas && project.areas.length) ? project.areas : [this.form.area]
        return projectAreas.map(i => ({
          ...project,
          area: i,
          value: { ...project },
          label: this.areas.length > 1 ? `${name} (${i.name})` : name
        }))
      }
      const list = this.projects.reduce((acc, curr) => [...acc, ...mapProjectToEntries(curr)], [])
      if (this.form.project && this.form.project.id && !list.some(i => i.id === this.form.project.id)) {
        list.push(...mapProjectToEntries(this.form.project))
      }
      return list.filter(i => {
        return !this.form.area || i.area.code === this.form.area.code
      })
    }
  },
  methods: {
    removeSubContractChip (index) {
      this.form.subContracts.splice(index, 1)
    }
  },
  watch: {
    'form.project' (v) {
      this.form.parts[0].name = v.name
    }
  }
}
</script>
